import { observer } from "mobx-react-lite";
import { useTran } from "@/hooks";
import ConfirmDialog from "./ConfirmDialog";
import { useUserStore } from "../hooks";

const DeleteUserDialog = observer(({ user, onClose }) => {
  const { t } = useTran();
  const { deleteLoading, markUserDeleted, loadUsers } = useUserStore();

  const handleConfirm = async () => {
    if (!user?.id) return { success: false };
    const result = await markUserDeleted(user.id);
    if (result?.success) {
      onClose?.();
      await loadUsers();
    }
    return result;
  };

  return (
    <ConfirmDialog
      open={Boolean(user)}
      onOpenChange={(openState) => {
        if (!openState) {
          onClose?.();
        }
      }}
      title={t("Delete user")}
      description={t("This will mark your user as deleted.")}
      confirmLabel={t("Delete")}
      cancelLabel={t("Cancel")}
      onConfirm={handleConfirm}
      loading={deleteLoading}
      tone="danger"
    />
  );
});

export default DeleteUserDialog;
